import { Wrench, Gauge, ClipboardCheck } from "lucide-react";

const features = [
  {
    title: "Auto Repair Facilities",
    description:
      "Optimize your repair process with VIN decoding, ADAS features identification, and automated estimate analysis.",
    icon: Wrench,
    features: [
      "VIN decoding for ADAS features",
      "OEM-compliant calibration requirements",
      "Comprehensive calibration reports",
      "Automated repair estimate analysis",
      "Customizable liability waivers",
    ],
  },
  {
    title: "Calibration Companies",
    description:
      "Streamline your calibration business with advanced system identification and documentation tools.",
    icon: Gauge,
    features: [
      "VIN-based ADAS system identification",
      "Calibration trigger analysis",
      "Calibration procedure documentation",
      "Customer and insurer reports",
      "Customizable liability waivers",
    ],
  },
  {
    title: "Insurance Adjusters",
    description:
      "Simplify your claims workflow with transparent reporting and validation tools.",
    icon: ClipboardCheck,
    features: [
      "Transparent calibration reports",
      "OEM calibration documentation",
      "Claim validation tools",
      "Real-time updates",
      "Comprehensive audit trail",
    ],
  },
];

export const Features = () => {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-3xl font-bold tracking-tight text-everest-gray sm:text-4xl">
          Solutions for Every Automotive Professional
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Choose the solution that best fits your business needs
        </p>
      </div>
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="relative rounded-xl border border-gray-200 bg-white p-6 shadow-sm transition-all hover:shadow-md"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-everest-teal">
              <feature.icon className="h-6 w-6 text-white" />
            </div>
            <h3 className="mt-4 text-xl font-semibold text-everest-gray">
              {feature.title}
            </h3>
            <p className="mt-2 text-gray-600">{feature.description}</p>
            <ul className="mt-4 space-y-3">
              {feature.features.map((item) => (
                <li key={item} className="flex items-center text-gray-600">
                  <div className="mr-2 h-1.5 w-1.5 rounded-full bg-everest-orange" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};